import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import LocationSvg from '../assets/Location.svg'
import CareerGrowthSvg from '../assets/Career-Growth.svg'
import LocallyOwnedSvg from '../assets/Locally-Owned.svg'
import QuotesSVG from '../assets/Quotes-Icon.svg'
import { isComponentType } from 'helpers/utils'

const BOTCareersContent = ({
  localStoreOpportunitiesMode,
  storeNumber,
  url,
  resourceUrl,
  linkText,
  showStoreLocatorModal,
  hasSelectedStore,
  hasResourceUrl,
  storeEmail,
  placeholders: {
    content = []
  } = {}
}) =>
  <Wrapper>
    {
      React.Children.map(
        content,
        child => React.cloneElement(
          child,
          !isComponentType('TeaserHtmlContentBlock', child) ?
            {
              localStoreOpportunitiesMode,
              storeNumber,
              url,
              resourceUrl,
              linkText,
              showStoreLocatorModal,
              hasSelectedStore,
              hasResourceUrl,
              storeEmail
            } : undefined
        )
      )
    }
  </Wrapper>

BOTCareersContent.propTypes = {
  hasResourceUrl: PropTypes.bool,
  hasSelectedStore: PropTypes.bool,
  linkText: PropTypes.string,
  localStoreOpportunitiesMode: PropTypes.string,
  placeholders: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.shape())
  }),
  resourceUrl: PropTypes.string,
  showStoreLocatorModal: PropTypes.func,
  storeEmail: PropTypes.string,
  storeNumber: PropTypes.string,
  url: PropTypes.string
}

export default BOTCareersContent

const Wrapper = styled.div`
  margin: 0;
  background: url("https://tbc.scene7.com/is/image/TBCCorporation/Main-Content-Background-Texture-Desktop?qlt=80&crop=132,66,68,67&scale=0.5") repeat;

  .ColoredText {
    font-size: inherit;
    font-weight: inherit;
    font-family: inherit;
    color: ${Theme.colors.red};
  }

  .LocationTile {
    background: url(${LocationSvg}) center / contain no-repeat;
  }

  .LocallyOwnedTile {
    background: url(${LocallyOwnedSvg}) center / contain no-repeat;
  }

  .CareerGrowth {
    background: url(${CareerGrowthSvg}) center / contain no-repeat;
  }

  .QuotesImg {
    background: url(${QuotesSVG}) center / cover no-repeat;
  }

  .BigOLine {
    font-size: 26px;
    font-weight: 700;
    color: #afafaf;
    margin-top: 0;
    line-height: 8px;
    margin-bottom: 25px;
  }
`
